<template>
  <div>
    <table class="table w-full mb-3">
      <thead>
        <tr>
          <th v-text="$t('sms')"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="mb-3">
              <vs-input :label="$t('receiver')" :placeholder="$t('receiver')" v-model="sendSmsFormData.number" class="w-full"/>
              <validation-error :model-error="sendSmsFormErrors.number"></validation-error>
            </div>

            <div class="mb-3">
              <vs-textarea class="mb-0 send-message-container" v-model="sendSmsFormData.message" />
              <validation-error :model-error="sendSmsFormErrors.message"></validation-error>
            </div>

            <div class="flex justify-between">
              <div>
                Bytes: <span v-text="sendSmsFormData.bytes"></span>
                <span v-if="sendSmsFormData.bytes <= 90">/90</span>
                <span v-else>/2000</span>
              </div>

              <div>
                <badge-sms-type :content="sendSmsFormData.bytes <= 90 ? 1 : 2"></badge-sms-type>
              </div>
            </div>
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td class="text-right">
            <vs-button color="success" type="filled" icon-pack="feather" icon="icon-send" size="small" @click="sendMessage">{{ $t('send_sms') }}</vs-button>
          </td>
        </tr>
      </tfoot>
    </table>

    <div>
      {{ $t('remaining_balance') }}:
      <span v-text="remainingBalance"></span>
      <br>
      <br>
      <vs-button color="primary" type="filled" @click.prevent="$emit('editCallbackNumber')">
        {{ $t('callback_number') }} : {{ callbackNumber }}
      </vs-button>
    </div>
  </div>
</template>

<script>
import BadgeSmsType from '@/components/badge/SmsType'
import Message from '@/models/Message'
import { EventBus } from '@/../eventbus.js'

export default {
  name: 'Form',
  components: {
    BadgeSmsType
  },
  data () {
    return {
      sendSmsFormData: {
        category: '',
        message: '',
        number: '',
        name: '',
        bytes: 0,
        sendImage: {
          file1: null,
          file2: null,
          file3: null
        }
      },
      sendSmsFormErrors: {}
    }
  },
  props: {
    remainingBalance: {
      type: Number,
      required: true
    },
    callbackNumber: {
      type: [String, Number],
      required: true
    },
    sendImage: {
      type: [Object],
      required: true
    }
  },
  watch: {
    'sendSmsFormData.message' (val) {
      this.sendSmsFormData.bytes = this.$stringHelper.getContentLength(val)
    }
  },
  mounted () {
    this.sendSmsFormData.number = this.givenNumber

    EventBus.$on('smsTemplateContentClicked', (content) => {
      this.sendSmsFormData.message = content
    })

    EventBus.$on('setGivenNumber', (number) => {
      this.sendSmsFormData.number = number
    })
  },
  methods: {
    async sendMessage () {
      if (this.remainingBalance > 0) {
        try {
          this.sendSmsFormData.sendImage = this.sendImage
          await Message.send(this.sendSmsFormData)

          this.$swalHelper.success({
            title: this.$t('has_been_sent'),
            text: this.$t('message_successfully_sent'),
            confirmButton: this.$t('confirm')
          })

          this.$emit('messageSent')
          this.resetSmsFormData()
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      } else {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: this.$t('send_sms_not_enough_balance'),
          confirmButton: this.$t('confirm')
        })
      }
    },
    resetSmsFormData () {
      const items = document.querySelectorAll('.base-image-input-delete-btn')
      items.forEach(item => {
        item.click()
      })
      this.sendSmsFormData.category = ''
      this.sendSmsFormData.message = ''
      this.sendSmsFormData.number = ''
      this.sendSmsFormData.name = ''
      this.sendSmsFormData.bytes = 0
    }
  }
}
</script>

<style>
.send-message-container .vs-textarea {
  resize: vertical !important;
  min-height: 230px;
}
</style>
